/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ICalloutProps, Target } from '@fluentui/react/lib/Callout';
import { getEventBus } from 'src/core/utils/eventBus';
import { LuisConstants } from 'src/core/utils/LuisConstants';
import { TeachingBubbleDto, TeachingBubblesKeys } from 'src/luis/projects/events/types/TeachingBubbleDto';

const eventBus = getEventBus();

/**
 * Helper function that wraps the event bus emission that's responsible for queueing teaching bubbles.
 */
export const queueTeachingBubble = (teachingBubbleDto: TeachingBubbleDto) => eventBus.emit('queueTeachingBubble', teachingBubbleDto);

/**
 * Helper function that wraps the event bus emission that's responsible for dequeueing teaching bubbles.
 */
export const dequeueTeachingBubble = (key: TeachingBubblesKeys) => eventBus.emit('dequeueTeachingBubble', key);

/**
 * Helper function that wraps the creation of teaching bubbles.
 */
export const createTeachingBubble = (
    key: TeachingBubblesKeys,
    body: string,
    title: string,
    target: Target,
    hasGotIt?: boolean,
    hasSkip?: boolean,
    calloutProps?: ICalloutProps,
    onDismiss?: () => void
) => {
    queueTeachingBubble({
        key,
        message: {
            body,
            title
        },
        config: {
            target,
            delay: LuisConstants.TeachingBubblesDelay,
            ...(Boolean(calloutProps) && { calloutProps })
        },
        hasGotIt,
        hasSkip,
        onDismiss
    });
};
